/** Rendered in place of the map when nothing has valid coordinates. The
 * Portuguese default lives here — the primitive that renders the string. */
export function NoAddressFallback({
  message = "Endereço não informado",
}: {
  message?: string;
}) {
  return (
    <div className="w-full h-full flex items-center justify-center bg-gray-100">
      <span className="text-sm text-gray-500">{message}</span>
    </div>
  );
}
